import { InjectableClass } from '@fino/lib-injection';

export class AppService extends InjectableClass {
  constructor($rootScope, $translate, store) {
    'ngInject';
    super({
      $rootScope,
      $translate,
      store,
    });
  }

  setLang(lang) {
    this.$translate.use(lang);
    this.store.set('lang', lang);
    this.notify('setLang', lang);
  }

  subscribe(event, scope, callback) {
    const handler = this.$rootScope.$on(event, callback);
    scope.$on('$destroy', handler);
  }

  notify(event, params) {
    this.$rootScope.$emit(event, params);
  }
}
